import React, {memo, useEffect, useState} from "react";
import {connect} from "formik";
import Dropzone from "react-dropzone";
import {Icon} from "@material-ui/core";
import LightTooltip from "../../../LigthTooltip";


const ImageFile = ({formik, name, className, label, multiple = false, maxFiles = 0}) => {
    const [error, setError] = useState('');
    const images = formik.values[name] ? multiple ? formik.values[name] : [formik.values[name]] : [];
    const showDropzone = (!multiple && !images.length) || (multiple && (!maxFiles || images.length < maxFiles));
    const touched = formik.touched[name];
    const formikError = formik.errors[name];

    useEffect(() => {
        if(touched) {
            setError(formikError);
        }
    }, [touched, formikError]);

    const handleChange = acceptedFiles => {
        formik.setFieldValue(name, multiple ? [...formik.values[name], ...acceptedFiles] : acceptedFiles[0]);
        formik.setFieldTouched(name,true);
        setError('');
    };

    const handleError = (files) => {
        let errorText = '';

        if(!!maxFiles && images.length + files.length > maxFiles) {
            errorText = `Количество загружаемых файлов не должно превышать ${maxFiles}`;
        } else {
            errorText = 'Формат файла не поддерживается, либо размер файла превышает 10Мб';
        }

        setError(errorText);
    };

    const handleDelete = index => {
        let newImages = [...images];
        newImages.splice(index, 1);

        formik.setFieldValue(name, multiple ? [...newImages] : '');
    };

    return (
        <div className={`image-file${className ? ' ' + className : ''}`}>
            <label htmlFor={name} className="image-file__label">{label}</label>
            <div className="image-file__content">
                {showDropzone &&
                    <Dropzone
                        accept={['.png', '.jpg', '.jpeg']}
                        maxSize={10485760} //10MB
                        maxFiles={multiple ? maxFiles ? maxFiles - images.length : 0 : 1}
                        multiple={multiple}
                        onDrop={handleChange}
                        onDropRejected={handleError}
                    >
                        {({getRootProps, getInputProps}) => (
                            <div className="image-file__dropzone" {...getRootProps()}>
                                <Icon fontSize="large" color="action">
                                    cloud_upload
                                </Icon>
                                <input
                                    name={name}
                                    id={name}
                                    className="image-file__input"
                                    type="file"
                                    onChange={e => handleChange(e.target.files)}
                                    {...getInputProps()}
                                />
                            </div>
                        )}
                    </Dropzone>
                }
                {images.map((file, i) =>
                    <div className="image-file__img" key={`img-${i}`}>
                        <div className="image-file__img-wrap">
                            <LightTooltip title="Удалить">
                                <Icon
                                    className="image-file__img-delete"
                                    fontSize="small"
                                    onClick={() => handleDelete(i)}
                                >delete</Icon>
                            </LightTooltip>
                        </div>
                        <img src={typeof file === 'string' ? file : URL.createObjectURL(file)} alt=""/>
                    </div>
                )}
            </div>
            {error &&
                <p className="image-file__error">{error}</p>
            }
        </div>
    )
};

export default memo(connect(ImageFile));